// Canonical platform stats used in marketing copy + SEO JSON-LD across the site.
//
// The numeric truth lives in ComparisonPage's SECTIONS array — it is the
// exhaustive head-to-head matrix that defines what the platform offers. We
// export the computed count from here so every other page (Features hero,
// Landing FAQ, Register meta, /vs/* pages, /best-* pages) shows the same
// number with no drift.
//
// Update flow: when a new feature ships, add it to ComparisonPage's SECTIONS.
// The count here auto-updates because both pages run the same counting code
// during build.

import { TOTAL_FEATURES } from '../pages/ComparisonPage';

export const PLATFORM_FEATURE_COUNT = TOTAL_FEATURES;

// Other stable platform numbers — change here once, reflect everywhere.
export const PLATFORM_CHAIN_COUNT = 15;
export const PLATFORM_CEX_COUNT = 15;
export const PLATFORM_DEX_BOT_COUNT = 11;
